import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

import { Button, Image, Space,Divider,Avatar, Card } from 'antd';


import { EditOutlined, EllipsisOutlined, SettingOutlined } from '@ant-design/icons';
import { productDetail } from './staticDataList';


const { Meta } = Card;


const ProductDetail = (props) => {
  const [t, i18n] = useTranslation();
  const [myCode, setMyCode] = useState('');

  const [random, setRandom] = useState();

  const code = props.code

  const getLocale=()=>{
    if(i18n.language.slice(0,2)=='en') return productDetail.en
    else return productDetail.tr
  }

  useEffect(() => {
    console.log("cmd",code)

  }, [code]);


  const setLang=(lang)=>{
    i18n.changeLanguage(lang)
    localStorage.setItem("lang",lang)
  }


  return (
    <div>
    <Card
    extra={
      <>
    <Button
    size='small'
      type={i18n.language=='tr' ? 'primary' : 'default'}
      onClick={() => {
        setLang('tr')
      }}
    >
      TR
    </Button>
    <Divider type='vertical'/>
    <Button
    size='small'
      type={i18n.language=='en' ? 'primary' : 'default'}
      onClick={() => {
        setLang('en')
      }}
    >
      EN
    </Button>
      </>
    }
    style={{ 
     // maxWidth:600
      //width: 300 
    }}
    title={getLocale().title}
    
    cover={
      <img
        alt="example"
        style={{
          maxWidth:600
        }}
        className='my-center'
        src={getLocale().images.cover}
      />
    }
  >
    <p>
     {getLocale().description}
    </p>
    <p>
     {getLocale().description1}
    </p>


    {
      getLocale().images.list.map((v,i)=>(
        <Image
        key={i}
        width={100}
        src={v}
        placeholder={
          <Image
            preview={false}
            src={v}
          //  width={200}
          />
        }
      />
      ))
    }


    <p>
      {getLocale().soaps.map((v,i)=>{
        return(
          <div key={i} style={{
            marginBottom:20
          }}>
            <div>
            <strong>{v.title}</strong>
            </div>
            <Image
                key={i}
                width={100}
                src={v.images.cover}
                placeholder={
                  <Image
                    preview={false}
                    src={v.images.cover}
                  //  width={200}
                  />
                }
              />
            {v.items.map((v,i)=>(<div key={i}>{v}</div>))}
          </div>
        )
      })}
    </p>


  </Card>
  



    </div>
  )
}

export default ProductDetail
